import React from 'react';
import { object, func } from 'prop-types';
import { map, get } from 'lodash';
import { Row, Icon, Text, Divider } from '../../common';

const Settings = ({ settings, handleModal, description }) => {
    return map(settings, (setting) => {
        return (<>
            <Row justify='space-between' padding='15px 20px' >
                <Text text={get(setting, 'value')} />
                <Icon name='trash' color='#A4C735' size={15} pointer onClick={async () => {
                    handleModal(get(setting, 'key'), description)
                }} />
            </Row>
            <Divider style={{ margin: '0px 20px', padding: 0 }} />
        </>);
    });
};

Settings.propTypes = {
    settings: object,
    handleModal: func
};

export default Settings;
